import script from "./StatisticsUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./StatisticsUsers.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__